import { createContext } from "react"
import type { LoginRequest, RegisterRequest, UserProfile, UserRole } from "@/shared/api/types"

export type AuthContextValue = {
  isLoading: boolean
  isAuthenticated: boolean
  account: UserProfile | null
  error: Error | null
  login: (returnTo?: string) => void
  authenticate: (credentials: LoginRequest) => Promise<UserProfile>
  register: (details: RegisterRequest) => Promise<UserProfile>
  logout: () => Promise<void>
  hasRole: (role: UserRole | UserRole[]) => boolean
}

export const AuthContext = createContext<AuthContextValue | null>(null)
